import { Link } from "react-router-dom";

function scrollToResourceCta(): void {
  document.getElementById("homepage-cta")?.scrollIntoView({
    behavior: "smooth",
    block: "start",
  });
  setTimeout(() => {
    const input = document.getElementById("footer-cta-email") as HTMLInputElement | null;
    if (!input) return;
    input.focus();
    input.style.outline = "2px solid rgba(255,255,255,0.75)";
    input.style.outlineOffset = "2px";
    setTimeout(() => {
      input.style.outline = "";
      input.style.outlineOffset = "";
    }, 1200);
  }, 700);
}

export default function ResourceHero() {
  return (
    <section
      id="resource-hero"
      className="w-full bg-black font-fira text-white pt-6 md:py-10"
    >
      {/* Frame: full width mobile, 98% desktop; 1px gradient border */}
      <div className="mx-auto w-[90%] md:w-[98%]">
        <div className="rounded-b-2xl rounded-t-none p-px md:rounded-b-3xl">
          <div className="relative min-h-[min(65dvh,44rem)] overflow-hidden rounded-3xl  md:min-h-[min(65dvh,40rem)] md:rounded-b-3xl border border-[#FFFFFF29]">
            {/* Background image */}
            <picture className="pointer-events-none absolute inset-0">
              <source
                media="(min-width: 768px)"
                srcSet="/resources/resourceherod.webp"
              />
              <img
                src="/resources/resourcehero.webp"
                alt=""
                className="h-full w-full object-cover object-center"
                loading="eager"
                decoding="async"
                fetchPriority="high"
              />
            </picture>

            {/* Dark overlay on the left so text is readable */}
            <div className="pointer-events-none absolute inset-0" />

            {/* Content */}
            <div className="relative z-10 flex min-h-[min(65dvh,44rem)] flex-col justify-end md:justify-center px-6 py-12 md:min-h-[min(65dvh,40rem)] md:px-16 md:py-16 ">
              <div className="flex md:max-w-xl flex-col items-start">
                <h1 className="font-fira-condensed text-[36px] font-medium md:font-semibold leading-tight tracking-tight text-white md:text-[56px]">
                  The AI learning 
                  <br />
                  hub for builders.
                </h1>

                <p className="font-fira mt-3 text-[14px] font-normal leading-relaxed text-[#FFFFFF80] md:mt-4 md:text-[18px]">
                  Hand-picked AI tools, videos, and resources. Tested before they make it in.
                </p>

                <div className="mt-6 hidden w-full flex-col items-center gap-3 md:mt-8 md:flex md:flex-row">
                  <button
                    type="button"
                    onClick={scrollToResourceCta}
                    className="w-full rounded-lg border border-[#FFFFFF4D] bg-white px-5 py-2.5 font-fira text-sm font-semibold text-black transition-opacity hover:opacity-90 md:w-auto md:px-6 md:text-[0.9375rem]"
                  >
                    Join the Community
                  </button>
                  <Link
                    to="/all-resources"
                    className="w-full rounded-lg border border-white/30 bg-transparent px-5 py-2.5 text-center font-fira text-sm font-medium text-white/50 transition hover:bg-white/5 md:w-auto md:px-6 md:text-[0.9375rem]"
                  >
                    Browse all Resources
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
